'use strict';

exports.__esModule = true;
exports.default = {
    el: {
        colorpicker: {
            confirm: 'OK',
            clear: 'Xóa'
        },
        datepicker: {
            now: 'Hiện tại',
            today: 'Hôm nay',
            cancel: 'Hủy',
            clear: 'Xóa',
            confirm: 'OK',
            selectDate: 'Chọn ngày',
            selectTime: 'Chọn giờ',
            startDate: 'Ngày bắt đầu',
            startTime: 'Thời gian bắt đầu',
            endDate: 'Ngày kết thúc',
            endTime: 'Thời gian kết thúc',
            prevYear: 'Năm trước',
            nextYear: 'Năm tới',
            prevMonth: 'Tháng trước',
            nextMonth: 'Tháng tới',
            year: '',
            month1: 'Tháng 1',
            month2: 'Tháng 2',
            month3: 'Tháng 3',
            month4: 'Tháng 4',
            month5: 'Tháng 5',
            month6: 'Tháng 6',
            month7: 'Tháng 7',
            month8: 'Tháng 8',
            month9: 'Tháng 9',
            month10: 'Tháng 10',
            month11: 'Tháng 11',
            month12: 'Tháng 12',
            // week: 'week',
            weeks: {
                sun: 'CN',
                mon: 'T2',
                tue: 'T3',
                wed: 'T4',
                thu: 'T5',
                fri: 'T6',
                sat: 'T7'

            },
            months: {
                jan: 'Tháng 1',
                feb: 'Tháng 2',
                mar: 'Tháng 3',
                apr: 'Tháng 4',
                may: 'Tháng 5',
                jun: 'Tháng 6',
                jul: 'Tháng 7',
                aug: 'Tháng 8',
                sep: 'Tháng 9',
                oct: 'Tháng 10',
                nov: 'Tháng 11',
                dec: 'Tháng 12'

            }
        },
        select: {
            loading: 'Đang tải',
            noMatch: 'Dữ liệu không phù hợp',
            noData: 'Không có dữ liệu',
            placeholder: 'Chọn'
        },
        cascader: {
            noMatch: 'Dữ liệu không phù hợp',
            loading: 'Đang tải',
            placeholder: 'Chọn'
        },
        pagination: {
            goto: 'Nhảy tới',
            pagesize: '/trang',
            total: 'Tổng {total}',
            pageClassifier: ''
        },
        messagebox: {
            title: 'Thông báo',
            confirm: 'OK',
            cancel: 'Hủy',
            error: 'Dữ liệu không hợp lệ'
        },
        upload: {
            deleteTip: 'Nhấn x để xoá',
            delete: 'Xóa',
            preview: 'Xem trước',
            continue: 'Tiếp tục'
        },
        table: {
            emptyText: '',
            confirmFilter: 'Xác nhận',
            resetFilter: 'Làm mới',
            clearFilter: 'Xóa hết',
            sumText: 'Tổng'
        },
        tree: {
            emptyText: 'Không có dữ liệu'
        },
        transfer: {
            noMatch: 'Dữ liệu không phù hợp',
            noData: 'Không tìm thấy dữ liệu',
            titles: ['Danh sách 1', 'Danh sách 2'],
            filterPlaceholder: 'Nhập từ khóa',
            noCheckedFormat: '{total} mục',
            hasCheckedFormat: '{checked}/{total} đã chọn '
        }
    }
};
